import { post, get } from '../../../components/hooks/apiFetch';

export const useMarketPriceAnalysisApi = () => {
    const submitMarketPriceAnalysisRequest = async (filesWithFormats, promptText, comment = '', startTime = '') => {
        comment ??= '';
        const formData = new FormData();
        filesWithFormats.forEach((item, index) => {
            formData.append(`Files[${index}].File`, item.file, item.file.name);
            formData.append(`Files[${index}].OutputFormat`, item.outputFormat);
            if (item.templateName && item.templateName.trim() !== '') {
                formData.append(`Files[${index}].TemplateName`, item.templateName);
            }
        });

        formData.append("Options.PromptText", promptText.trim());
        formData.append("Options.Comment", comment.trim());
        formData.append("Options.StartTime", startTime);

        const result = await post(`/api/MarketPriceAnalysis`, formData);

        return {
            id: result.id,
            identifier: result.identifier
        };
    };

    const cancelMarketPriceAnalysisTask = async (inputIdentifier) => {
        await get(`/api/MarketPriceAnalysis/cancel/${encodeURIComponent(inputIdentifier)}`);
        return true;
    };

    return { submitMarketPriceAnalysisRequest, cancelMarketPriceAnalysisTask };
};